import React, { useEffect, useState } from "react";
import {
  // fetchMultibetleaguesDataApi,
  fetchTriplemarketsDataApi,
  fetchTripleDataApi,
  fetchTripleReplaceDataApi,
} from "../api/api";
import LeagueMultiSelect from "./Treblewin/LeagueMultiSelect";
import MarketMultiSelect from "./Treblewin/MarketMultiSelect";
import { formatDate, totalOddsCal, formatValue } from "../helper/index";

const BETWAY_URL = process.env.REACT_APP_BETWAY;

function Treblewin({ oddsFormat, leagueData, language }) {
  // const [leagueData, setLeagueData] = useState([]);
  const [leagueId, setLeagueId] = useState("");
  const [mastermarketid, setMastermarketid] = useState("");
  const [marketData, setMarketData] = useState([]);
  const [marketBetbuilderArray, setMarketBetbuilderArray] = useState([]);
  // const [isLoadingLeagueData, setIsLoadingLeagueData] = useState(false);
  const [isLoadingMatchData, setIsLoadingMatchData] = useState(false);
  const [isLoadingSearchData, setIsLoadingSearchData] = useState(true);
  const [totalOdds, setTotalOdds] = useState("");
  const [shouldProcessData, setShouldProcessData] = useState(true);
  const [alertMessage, setAlertMessage] = useState("");
  const [refreshloading, setRefreshloading] = useState(false);
  const [resetCounter, setResetCounter] = useState(0);


  useEffect(() => {
    const fetchMarketData = async () => {
      try {
        setIsLoadingMatchData(true);
        const marketData = await fetchTriplemarketsDataApi(language);
        const data = marketData.data;
        setMarketData(data);
        // setMastermarketid(data[0].mastermarketid)
        setIsLoadingMatchData(false);
      } catch (error) {
        console.error("Error fetching league data:", error);
        setIsLoadingMatchData(false);
      }
    };
    fetchMarketData();
  }, [language]);

  const handleSearchClick = async () => {
    setIsLoadingSearchData(true);
    setMarketBetbuilderArray([]);

    // console.log(mastermarketid, leagueId)
    // setShouldProcessData(true);

    try {
      const resDataBetBuilder = await fetchTripleDataApi(
        language,
        leagueId,
        mastermarketid,
        
      );

      if (resDataBetBuilder.statuscode === 400) {
        setMarketBetbuilderArray([]);
      }

      if (resDataBetBuilder && resDataBetBuilder.data.length > 0) {
        const totalOdds = totalOddsCal(oddsFormat, resDataBetBuilder.data)
        setTotalOdds(totalOdds);
        setMarketBetbuilderArray(resDataBetBuilder.data);
      } else {
        setMarketBetbuilderArray([]);
        setTotalOdds('0.00')
      }

      setShouldProcessData(false);
      setIsLoadingSearchData(false);
    } catch (error) {
      console.error("Error fetching bet builder data:", error);
      setIsLoadingSearchData(false);
    }
  };

  useEffect(() => {
    if (shouldProcessData) {
      const fetchData = async () => {
        try {
          const resDataBetBuilder = await fetchTripleDataApi(language);
          if (resDataBetBuilder && resDataBetBuilder.data.length > 0) {
            const totalOdds = totalOddsCal(oddsFormat, resDataBetBuilder.data)
            setTotalOdds(totalOdds);
            setMarketBetbuilderArray(resDataBetBuilder.data);
          } else {
            console.error("Error fetching TripleData:");
            // setError1(true);
          }
        } catch (error) {
          console.error("Error fetching TripleData:", error);
        } finally {
          setIsLoadingSearchData(false);
        }
      };
      fetchData();
      setShouldProcessData(false);
    }
  }, [language, shouldProcessData, oddsFormat]);

  useEffect(() => {
    if (shouldProcessData) {
      setShouldProcessData(false);
    }
  }, [shouldProcessData]);

  const handleBetBuilderRefresh = async (
    event,
    matchid,
    leagueId,
    mastermarketid
  ) => {
    event.stopPropagation();
    try {
      setRefreshloading(true)
      const excludedMatchIds = marketBetbuilderArray
        .map((item) => item.matchid)
        .join(",");
      const resDataBetBuilder = await fetchTripleReplaceDataApi(
        excludedMatchIds,
        leagueId,
        mastermarketid,
        language
      );

      if (resDataBetBuilder.statuscode === 404) {
        setRefreshloading(false)
        setAlertMessage((prevMessages) => ({
          ...prevMessages,
          [matchid]: "No replacement available",
        }));
      } else {
        const updatedRowData = resDataBetBuilder.data;

        if (updatedRowData && updatedRowData.length > 0) {
          setMarketBetbuilderArray((prevData) => {
            const newData = [
              ...prevData.filter((item) => item.matchid !== matchid),
              ...updatedRowData,
            ];

            const totalOdds = totalOddsCal(oddsFormat, newData)
            setTotalOdds(totalOdds);
            

            return newData;
          });
          setRefreshloading(false)
        } else {
          setRefreshloading(false)
          setAlertMessage((prevMessages) => ({
            ...prevMessages,
            [matchid]: "No replacement available",
          }));

          setTimeout(() => {
            setAlertMessage((prevMessages) => {
              const updatedMessages = { ...prevMessages };
              delete updatedMessages[matchid];
              return updatedMessages;
            });
          }, 3000);
        }
      }
    } catch (error) {
      console.error("Error refreshing bet builder data:", error);
    } finally {
      setRefreshloading(false)
      // setRowLoading((prev) => ({ ...prev, [matchid]: false }));
    }
  };

  useEffect(() => {
  if (marketBetbuilderArray.length > 0) {
    const updatedTotalOdds = totalOddsCal(oddsFormat, marketBetbuilderArray);
    setTotalOdds(updatedTotalOdds);
  }
}, [oddsFormat, marketBetbuilderArray]);

const handleRefresh = () => {
  // Reset the filters used for API calls
  setLeagueId("");
  setMastermarketid("");
  setResetCounter(prev => prev + 1);

  // If you later separate "selected value" from API filters,
  // don't reset those here so the dropdown visually stays selected
};


  return (
    <>
      <div className="AF-widget AF-multiBets" style={{position:'relative'}}>
        <div className="AF-widget__header">
          <div className="grid-noGutter-middle">
            <div className="col-4_lg-4_md-4_sm-4_xs-12" style={{marginBottom : '10px'}}>
              <span className="AF-widget__title">TREBLE WIN</span>{" "}
              <span className="tooltip-wrapper-multibet-title">
                <img src="assets/images/fire-icon.svg" alt="fire-icon" className="fire-icon" />
                <span className="tooltip-text-multibet-title">
                  Generates a treble from your chosen market & league filters, showing the strongest bets from the next 3 matches to kick off.
                </span>
              </span>
            </div>
            <div className="col-8_lg-8_md-8_sm-8_xs-12">
              <div className="container">
                <div className="tri_space">
                  <LeagueMultiSelect
                    leagueData={leagueData}
                    setLeagueId={setLeagueId}
                    resetTrigger={resetCounter}
                  />
                </div>
                <div className="tri_space">
                  <MarketMultiSelect
                    marketData={marketData}
                    isLoadingLeagueData={isLoadingMatchData}
                    setMastermarketid={setMastermarketid}
                    resetTrigger={resetCounter}
                  />
                </div>
                <div className="tri_space">
                  <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                  <svg
                    className="icon"
                    viewBox="0 0 30 30"
                    id="btn_treble_referesh"
                    onClick={handleRefresh}
                  >
                    <path
                      fill="#fff"
                      d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"
                    />
                  </svg>


                  <button
                    style={{marginLeft:'10px'}}
                    className="btn AF-btnOrange active Af-newbtnSmall go_btn"
                    onClick={handleSearchClick}
                    id="btn_treble_go"
                  >
                    GO
                  </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {refreshloading && (
          <div className="trible-loading-overlay">
            <div className="spinner-loading"></div>
          </div>
        )}

        <div className="AF-widget__content p-0">
          {marketBetbuilderArray && marketBetbuilderArray.length > 0 ? (
            <div className="AF-multiBet-carousel">
              {marketBetbuilderArray.slice(0, 3).map((item, index) => (
                <div className="carousel-cell" key={index}>
                  <div className="AF-multiBetMatchBox">
                    {alertMessage[item.matchid] && (
                      <div className="loading-container">
                        <div className="error-text">{alert}</div>
                      </div>
                    )}
                    <div className="AF-multiBetMatchBox__headerSection">
                      <div className="AF-tip">
                        <img src="assets/images/tip-icon.svg" alt="tip-icon" />
                      </div>
                      <div className="AF-MB__league truncate" style={{fontSize : '13px'}}>
                        {item.countryname} - {item.leaguename}{" "}
                      </div>
                    </div>
                    <div className="AF-multiBetMatchBox__fixtureSection">
                      <div className="AF-MB__kickOff">
                        {formatDate(item.matchutcdatetime)}
                        <div className="AF-MB__divider"></div>
                      </div>
                      <ul className="AF-MB__homeTeamAwayTeam">
                        <li className="AF-MB__homeTeam">{item.hometeamname}</li>
                        <li className="AF-MB__vs">
                          <img src="assets/images/vs.svg" alt="vs" />
                        </li>
                        <li className="AF-MB__awayTeam">{item.awayteamname}</li>
                      </ul>
                    </div>
                    <div className="AF-multiBetMatchBox__RTBSection">
                      {/* <div className="AF-MB__tip">TIP</div> */}
                      <div className="AF-MB__RTB">{item.keystats}</div>
                    </div>
                    <div className="AF-multiBetMatchBox__footerSection trible-fotter">
                      <div className="AF-MB__marketOdds">
                        {item.odds.decimalodds === null || item.odds.decimalodds === '1.01' || item.odds.decimalodds == 0 || item.odds.decimalodds === 1.01 ? 
                          <div className="email-error-msg">Odds currently unavailable</div>
                          :
                          <ul>
                            <li className="AF-MB__maket truncate trible-fotter-text">
                              {item.bestbetname}
                            </li>
                            
                            <li className="AF-MB__odds trible-fotter-text">
                              {oddsFormat==='EU' ? parseFloat(item.odds.decimalodds).toFixed(2) : formatValue(item.odds.americanodds)}
                            </li>
                          </ul>
                        }
                      </div>
                      <div className="AF-MB__stake text-center">
                        {/* <ul>
							<li className="active">&pound;5</li>
							<li>&pound;10</li>
							<li>&pound;15</li>
							<li>&pound;20</li>
							<li>&pound;25</li>
							</ul> */}
                      </div>
                      <div className="AF-MB__footer">
                        <ul>
                          {/* <li><img src="assets/images/no-icon-red.svg" /></li> */}
                          <li>
                            <span className="refresh-icon">
                              <svg
                                className="icon"
                                viewBox="0 0 30 30"
                                id="btn_treble_referesh"
                                onClick={(event) =>
                                  handleBetBuilderRefresh(
                                    event,
                                    item.matchid,
                                    leagueId,
                                    mastermarketid
                                  )
                                }
                              >
                                <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
                              </svg>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : isLoadingSearchData ? (
            <div className="loading-container">
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="loading-container">
              <div className="error-text">No data available</div>
            </div>
          )}
        </div>

        <div className="AF-widget__footer p-0">
          <div className="grid-middle-noGutter">
            <div className="col-12_lg-12_md-12_sm-12_xs-12">
              <div className="AF-parent-container ">
                  
                <button
                  className="trible_odds_btn"
                  onClick={() => window.open(BETWAY_URL, '_blank', 'noopener,noreferrer')}
                >
                  <span className="AF-totalOdds__value">{totalOdds}</span>
                </button>
              </div>
              {/* <ul className="AF-totalOdds-stake-earn">
								<li>
									<div className="AF-totalOdds">
										<span className="AF-totalOdds__txt">Total Odds: </span>
										<span className="AF-totalOdds__value"> {totalOdds}</span>
									</div>
								</li>
								<span>
									 <div className="AF-stake">
										<span>Stake: </span>
										<div className="AF-formControl">
											<input type="text" value="10" />
										</div>												
									</div> *
								</span>
								<span>
									 <div className="AF-totalEarn">
										<span>and you can earn: </span>
										<span className="AF-totalEarn__value">{(totalOdds * stake).toFixed(2)}</span>
									</div> 
								</span>
							</ul> */}
            </div>
            {/* <div className="col-4_lg-4_md-4_sm-12_xs-12">
							<div className="AF-addAllToBetslip__btn">
								<ul className="AF-addAllToBetslip">
									<li><img src="assets/images/betslip-icon.png" alt="slip"/></li>
									<li>Add all to Betslip</li>
								</ul>
							</div>
							
						</div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default Treblewin;
